import type { ObjectType } from '@quromedical/fhir-common';
import * as yup from 'yup';

import type { ObservationPregnancy } from './schema';

export const PregnancySchema = yup.object<ObjectType<ObservationPregnancy>>({
  isPregnant: yup.boolean().optional(),
  lactation: yup.boolean().optional(),
  edd: yup.string().optional(),
});
